import UUIDBase from "@/models/UUIDBase";
import Dinero, {Currency, Dinero as DineroType} from "dinero.js";
import CustomPriceType from "@/models/inventory/CustomPrice";

export default class ItemPackCustomPrice extends UUIDBase {
    static from(json: Record<string, unknown> | ItemPackCustomPrice) {
        const itemPackCustomPrice = Object.assign(new ItemPackCustomPrice(), json)


        if (itemPackCustomPrice.salePriceAmount && itemPackCustomPrice.salePriceCurrency) {
            itemPackCustomPrice.salePriceDinero = Dinero({
                amount: itemPackCustomPrice.salePriceAmount,
                currency: itemPackCustomPrice.salePriceCurrency as Currency,
                precision: itemPackCustomPrice.salePricePrecision
            })
        }

        itemPackCustomPrice.createdAt = new Date(json.createdAt as string)
        itemPackCustomPrice.updatedAt = new Date(json.updatedAt as string)
        itemPackCustomPrice.deletedAt = json.deletedAt ? new Date(json.deletedAt as string) : undefined

        return itemPackCustomPrice
    }

    itemPackID?: string
    customPriceTypeID?: string
    customPriceType?: CustomPriceType

    salePriceAmount?: number
    salePriceCurrency?: string
    salePricePrecision?: number
    salePriceDinero?: DineroType

    disabled = false
}
